import { ResourceContext } from '../core/resourceContext';

export const createContextUrl = (url: string, context: ResourceContext): string => {
  const encodedContext = encodeURIComponent(JSON.stringify(context));
  return url.includes('?') ? `${url}&context=${encodedContext}` : `${url}?context=${encodedContext}`;
};
